import 'vuetify/dist/vuetify.min.css';
import 'alertifyjs/build/alertify.min.js';
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import './db.js';

import './styles/index.scss';
import './styles/emojis.css';

import Vue from 'vue';
// import Vuex from 'vuex';
import Vuetify from 'vuetify';
// import VueChatScroll from 'vue-chat-scroll';
// import './registerServiceWorker';
import colors from 'vuetify/lib/util/colors';

import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css';

import VAnimateCss from 'v-animate-css';

import {
  firestorePlugin,
} from 'vuefire';
import FlagIcon from 'vue-flag-icon';
import VueLazyload from 'vue-lazyload';
import firebase from 'firebase';
import VueTagManager from 'vue-tag-manager';
// import LoadScript from 'vue-plugin-load-script';
// import { createLocalStore } from './store';
import store from './store/store';
import router from './router';
import App from './App.vue';

// import { paypal } from './config.js';

const DEFAULT_PAGE_TITLE = 'CHANCE4TALENTS';

// init messaging service worker, firebase .initializeApp(firebaseConfig) done in db.js
Vue.prototype.$messaging = null;
if (firebase.messaging.isSupported()) {
  // Retrieve Firebase Messaging object, assign to Vue Object
  Vue.prototype.$messaging = firebase.messaging();
  // Add the public key generated from the Firebase console
  // Vue.prototype.$messaging.usePublicVapidKey(process.env.VAPID_KEY);

  // Change server-worker.js register path
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      Vue.prototype.$swRegistration = registration;
      Vue.prototype.$messaging.useServiceWorker(registration);
    }).catch((err) => {
      console.log(err);
    });
}


// Vue.use(Vuex);
Vue.use(VueLazyload);
Vue.use(VueCroppie);
Vue.use(FlagIcon);
Vue.use(VAnimateCss);
// Vue.use(VueChatScroll);
Vue.use(VueTagManager, {
  gtmId: 'GTM-MRL8M3M',
});

// Vue.use(LoadScript);

// Vue.loadScript(`https://www.paypal.com/sdk/js?client-id=${paypal.clientId}&currency=EUR`);

Vue.use(Vuetify, {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: colors.red.darken1, // #E53935
        secondary: colors.red.lighten4, // #FFCDD2
        accent: colors.indigo.base, // #3F51B5
      },
    },
  },
});

Vue.use(firestorePlugin, { wait: true }); // waits to put results to variable

Vue.config.productionTip = false;


router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  const { currentUser } = firebase.auth();
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next('/');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }
});

router.afterEach((to) => {
  Vue.nextTick(() => { document.title = to.meta.pageTitle || DEFAULT_PAGE_TITLE; });
});

export default new Vue({
  router,
  // store: createLocalStore(),
  store,
  render(h) {
    return h(App);
  },
}).$mount('#app');
